import { processActions } from "./ProcessReducer";
import { useProcessAPI  } from '../../../api/process/useProcessAPI';

export const useProcess = () => {
    const api = useProcessAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.process.get(params);
              dispatch(processActions.funGetProcess(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.process.post(data);
        },
        put: async (data) => {
          return await api.process.put(data);
        },
        delete: async (params) => {
          return await api.process.delete(params);
        }
    };
    return { request };
  };